import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import messageHandler from '../utils/messageHandler';

const searchesSlice = createSlice({
  name: 'searches',
  initialState: {
    searches: null
  },
  reducers: {
    setSearches: (state, { payload }) => {
      state.searches = payload;
    }
  }
});

export const { setSearches } = searchesSlice.actions;
const token = localStorage.getItem('token');

export const getSearches =
  (id, page = 0) =>
  async dispatch => {
    try {
      const response = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_SERVER}/searches/get-by-user/${id}?offset=${page}&limit=20`,
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      dispatch(setSearches(response.data));
    } catch (e) {
      messageHandler('error', e.response.data.message);
    }
  };

export const addSearch = (userId, body) => async () => {
  try {
    const response = await axios({
      method: 'POST',
      url: `${process.env.REACT_APP_SERVER}/searches/user/${userId}`,
      data: body,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    messageHandler('success', response.data.message);
    return response.status;
  } catch (e) {
    messageHandler('error', e.response.data.message);
  }
};

export const deleteSearch = data => async () => {
  try {
    const response = await axios({
      method: 'DELETE',
      url: `${process.env.REACT_APP_SERVER}/searches`,
      data,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response;
  } catch (e) {
    console.log('error: ', e.response.data.message);
  }
};

export const updateSearch = (id, body) => async () => {
  try {
    const response = await axios({
      method: 'PATCH',
      url: `${process.env.REACT_APP_SERVER}/searches/${id}`,
      data: body,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    messageHandler('success', response.data.message);
  } catch (e) {
    messageHandler('error', e.response.data.message);
  }
};

export const updateAlertType = (searchId, body) => async () => {
  try {
    await axios({
      method: 'PATCH',
      url: `${process.env.REACT_APP_SERVER}/searches/update-alerts/${searchId}`,
      data: body,
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    messageHandler('success', 'Alerta actualizada correctamente');
  } catch (e) {
    messageHandler('error', e.response.data.message);
  }
};

export default searchesSlice.reducer;
